import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      width: 560,
    },
    dialogContent: {
      padding: theme.spacing(3),
    },
    field: {
      width: '100%',
    },
    dialogActions: {
      padding: theme.spacing(2, 5),
    },
    checkboxLabel: {
      ...theme.typography.regular12,
      color: COLORS.gray.gray30,
    },
  }),
  { name: 'BranVoicePopup' }
);
